import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UseMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, createdAt: any, email: string, name: string, profileUrl: string, phoneNumber?: string | null, sendbirdUserId?: string | null, userRole: { __typename?: 'UserRoleType', id: string, operationPermissions: Array<{ __typename?: 'OperationPermission', domain: Types.Domain, operations: Array<Types.Operation> }> }, organization: { __typename?: 'Organization', id: string, name: string, associatedOrganizations: Array<{ __typename?: 'Organization', id: string, name: string }> } } | null };


export const UseMeDocument = gql`
    query UseMe {
  me {
    id
    createdAt
    email
    name
    profileUrl
    phoneNumber
    sendbirdUserId
    userRole {
      id
      operationPermissions {
        domain
        operations
      }
    }
    organization {
      id
      name
      associatedOrganizations {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUseMeQuery__
 *
 * To run a query within a React component, call `useUseMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseMeQuery(baseOptions?: Apollo.QueryHookOptions<UseMeQuery, UseMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMeQuery, UseMeQueryVariables>(UseMeDocument, options);
      }
export function useUseMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMeQuery, UseMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMeQuery, UseMeQueryVariables>(UseMeDocument, options);
        }
export function useUseMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseMeQuery, UseMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMeQuery, UseMeQueryVariables>(UseMeDocument, options);
        }
export type UseMeQueryHookResult = ReturnType<typeof useUseMeQuery>;
export type UseMeLazyQueryHookResult = ReturnType<typeof useUseMeLazyQuery>;
export type UseMeSuspenseQueryHookResult = ReturnType<typeof useUseMeSuspenseQuery>;
export type UseMeQueryResult = Apollo.QueryResult<UseMeQuery, UseMeQueryVariables>;
export const namedOperations = {
  Query: {
    UseMe: 'UseMe'
  }
}